import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import GlobalSearchCommonUtility from '@sparta.global-gt.utilities/global-search-common-utility/dist/es6.js';
import GlobalSearchJcrUtility from '@sparta.global-gt.utilities/global-search-jcr-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import { cardHelper } from '@sparta.global.helpers/card-helper/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

/**
 * A class that binds data with the view and attaches all the required events to search input box.
 */
class AutoCompleteController {
  /**
     * Creates an instance of AutoCompleteController.
     * @param {object} options which holds view and model for input box.
     * @memberof GlobalSearchModule
     */
  constructor(options = {}) {
    this.autoCompleteView = options.view;
    this.autoCompleteModel = options.model;
    this.moduleInstance = options.moduleInstance;
    this.container = options.container;
    this.flyoutWrapperClass = '#global-search-flyout-wrapper';
    this.inputUITargetClass = '.nav-type-ahead .type-ahead';
    this.closeLinkClass = '.clear-autocomplete-history';
    this.flyoutWrapperElem = null;
    this.suggestionsListContainerClass = '.spa-global-search-suggestions--list';
    this.suggestionsContainerClass = '.spa-global-search-suggestions spa-global-search--partial';
    this.searchPartialListClass = '.spa-global-search--page .spa-global-search--partial-list';
    this.widgetContainerId = '#spa-global-search-widget-container';
    this.searchPartialList = null;
    this.onLoad = true;
    this.viewport = 'large';
    const mediaQueryData = this.moduleInstance.Store.getData('currentMQ');
    //set viewport for responsive page | for non-responsive keep large
    if (mediaQueryData && document.getElementsByTagName('body')[0]?.dataset?.spartaVersion) {
      this.viewport = mediaQueryData.viewport;
    }
    this.inputTextboxId = '#nav-search-query';
    this.clearSearchLinkId = '#global-search-input-close-link';
    this.searchButtonId = '#global-search-button';
    /**
      * for new unauth search view is same across view ports
      * so no need to change the elements
    */
    if (this.moduleInstance?.widgetInfo?.name !== "gt-search-public-widget") {
      if (this.viewport.indexOf('medium') > -1 && this.moduleInstance.inputExperience.toLowerCase() === 'header') {
        this.inputTextboxId = '#nav-search-query-md';
        this.clearSearchLinkId = '#global-search-input-close-link-md';
        this.searchButtonId = '#global-search-button-md';
      }
    }
    this.inputTextbox = null;
    this.inputTextboxContainerClass = '.spa-global-search-form--lg';
    this.submitButtonClass = '.submit';
    this.submitButton = null;
    this.isLastHistroyItem = false;
    this.clearSearchLink = null;
    this.suppressUIRender = false;
    this.data = null;
    this.searchButton = null;
    this.searchIconSpanClass = '.spa-circle-btn-icon';
  }

  /**
     * Called when this controller is bootstrapped by the module.
     * @returns {void}
     */
  init() {
    this.moduleInstance.Events.sub('global.search.query-updated', $.proxy(this.handleQueryUpdated, this));
    this.moduleInstance.Events.sub('global.search.request-updated', $.proxy(function () {
      this.suppressUIRender = true;
    }, this));
    this.moduleInstance.Events.sub('global.search.hide-popup', $.proxy(this.hidePopup, this));
    this.moduleInstance.Events.sub('global.search.focus-out', $.proxy(this.hidePopup, this));
    this.moduleInstance.Events.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, data => {
      if (data && data.data && data.data.viewport) {
        this.hidePopup();
      }
    });
    document.addEventListener('gt.globalsearch.ui-show', args => {
      this.widgetContainerId = '#'.concat(args.detail.container);
    });
  }

  /**
     * Called to render the module.
     * @param {object} options The options this module was initialized with.
     * @returns {void}
     */
  render(options = {}) {
    this.container = options.target;
    this.inputTextbox = $(this.container).find(this.inputTextboxId);
    this.searchButton = $(this.container).find(this.searchButtonId);
    this.inputTextbox.attr('aria-describedby', '');
    this.searchButton.removeAttr('aria-expanded');
    this.autoCompleteModel.getData(options).then($.proxy(this.getDataSuccess, this), $.proxy(this.getDataFailed, this));
  }

  /**
     * Called when this getdata method returns data.
     * @param {object} data The options this method was initialized with.
     * @returns {void}
     */
  getDataSuccess(data) {
    if (this.suppressUIRender === true) {
      return;
    }
    if (data) {
      this.data = data;
      const searchSuggestionsView = moduleConfig.partials['search-suggestions'];
      const view = this.autoCompleteView.getView();
      const container = $(this.container);
      if (view && container) {
        let flyoutElem;
        if (this.viewport.indexOf('medium') > -1 && !this.onLoad && this.moduleInstance.inputExperience.toLowerCase() === 'header') {
          flyoutElem = $(this.flyoutWrapperClass).find('.spa-card__body');
          const listPartialElm = flyoutElem.find('.spa-global-search-suggestions');
          listPartialElm.html(searchSuggestionsView({
            data: data.cardDetails
          }));
        } else {
          this.flyoutWrapperElem = document.querySelector(this.flyoutWrapperClass);
          if (this.flyoutWrapperElem) {
            this.flyoutWrapperElem.remove();
          }
          const flyoutView = moduleConfig.partials['flyout'];
          container.append(view({
            data: data
          }, {
            helpers: {
              cardHelper
            },
            partials: {}
          }));
          flyoutElem = $(this.flyoutWrapperClass).find('.spa-card__body');
          flyoutElem.html(flyoutView({
            data: data
          }));
          const listPartialElm = flyoutElem.find('.spa-global-search-suggestions');
          listPartialElm.html(searchSuggestionsView({
            data: data.cardDetails
          }));
        }
        if (this.moduleInstance.inputExperience.toLowerCase() === 'header' && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout' && this.viewport.indexOf('small') > -1) {
          $(this.flyoutWrapperClass).removeClass('spa-card spa-card--medium spa-card--overlay');
        }
        $(this.flyoutWrapperClass).find('.spa-card__dismissible').on('click', $.proxy(this.hidePopup, this));
        this.searchPartialList = container.find(this.searchPartialListClass);
        this.moduleInstance.Events.sub('global.search.escape-clicked', $.proxy(this.hidePopup, this));
        this.attachEvents();
        this.onLoad = false;
        if (this.viewport.indexOf('medium') > -1 && this.moduleInstance.inputExperience.toLowerCase() === 'header') {
          this.inputContainer = flyoutElem.children('.spa-global-search--flyout').find('#global-search-input-container-md');
          this.moduleInstance.Events.pub('global.search.medium-breakpoint', {
            target: this.inputContainer,
            focusInput: true
          });
          this.inputTextbox = $(this.container).find(this.inputTextboxId);
        }
      }
      this.flyoutWrapperElem = document.querySelector(this.flyoutWrapperClass);
      if (this.flyoutWrapperElem) {
        this.flyoutWrapperElem.classList.add('show-search');
        if (this.moduleInstance.inputExperience.toLowerCase() !== 'stage') {
          this.flyoutWrapperElem.classList.add('spa-global-search-flyout-pos--right');
        }
      }
      if ($(this.container).find(this.inputTextboxContainerClass) && this.moduleInstance.inputExperience.toLowerCase() === 'stage') {
        $(this.container).find(this.inputTextboxContainerClass).addClass('show');
      }
      if (this.inputTextbox) {
        this.inputTextbox.attr('aria-expanded', 'true');
        let adaId = this.inputTextbox.attr('id') + '_ada';
        this.inputTextbox.prev().find('.ada-hidden').attr('id', adaId);
        this.inputTextbox.attr('aria-describedby', adaId);
        this.inputTextbox.prev().find('.ada-hidden').text(this.data.labels.inputSuggestedSearchAvailable);
      }
      if (this.viewport.indexOf('medium') > -1) {
        this.searchButton = $(this.flyoutWrapperClass).find(this.searchButtonId);
      }
      this.searchButton.removeAttr('aria-expanded');
      const searchIconSpan = $(this.searchButtonId).find(this.searchIconSpanClass);
      searchIconSpan.removeAttr('aria-expanded');
      if (bactm) {
        bactm.rescanDOM();
      }
    }
  }

  /**
     * Called after history deleted.
     * @param {object} data The options this method was initialized with.
     * @returns {void}
     */
  getDataSuccessAfterDelete(data) {
    this.getDataSuccess(data);
    if (this.isLastHistroyItem == true) {
      window.setTimeout($.proxy(function () {
        $(this.inputTextbox).focus();
      }, this), 200);
    } else {
      window.setTimeout($.proxy(function () {
        const flyoutLiElm = $(this.container).find('.spa-global-search-suggestions--list li');
        flyoutLiElm.last().find('a').focus();
      }, this), 200);
    }
  }

  /**
     * Hides autocomplete popup.
     * @param {object} args The options this method was initialized with.
     * @returns {void}
     */
  hidePopup(args) {
    if (this.inputTextbox) {
      this.inputTextbox.attr('aria-expanded', 'false');
      this.inputTextbox.attr('aria-describedby', '');
      if (this.moduleInstance.inputExperience.toLowerCase() === 'stage') {
        this.inputTextbox.prev().find('.ada-hidden').text('');
      } else {
        if (this.data && this.data.labels) {
          this.inputTextbox.prev().find('.ada-hidden').text(this.data.labels.placeholder);
        }
      }
      if (args && args.event === "global.search.escape-clicked") {
        if ($(this.flyoutWrapperClass).is(':visible')) {
          $(this.inputTextbox).focus();
        }
      }
    }
    if (this.flyoutWrapperElem) {
      this.flyoutWrapperElem.classList.remove('show-search');
    }
    if ($(this.container).find(this.inputTextboxContainerClass) && this.moduleInstance.inputExperience.toLowerCase() === 'stage') {
      $(this.container).find(this.inputTextboxContainerClass).removeClass('show');
    }
  }

  /**
     * Called when this getdata method not returns data.
     * @param {object} data The options this module was initialized with.
     * @returns {void}
     */
  getDataFailed(data) {
    // do nothing
  }

  /**
     * Subscription method for Query Updated event.
     * @param {query} query holds updated query.
     * @returns {void}
     */
  handleQueryUpdated(query) {
    this.suppressUIRender = false;
    this.render(query.data);
    this.clearSearchLink = $(document).find(this.clearSearchLinkId);
    if (this.viewport.indexOf('medium') > -1) {
      this.searchButton = $(this.flyoutWrapperClass).find(this.searchButtonId);
    }
    this.searchButton.removeAttr('aria-expanded');
    const searchIconSpan = $(this.searchButtonId).find(this.searchIconSpanClass);
    searchIconSpan.removeAttr('aria-expanded');
  }

  /**
     * Show/hides close link.
     * @param {string} inputText text present in input box.
     * @returns {void}
     */
  toggleCloseLink(inputText) {
    const className = sparta && sparta.language && sparta.language === 'es' ? 'clear-input-es' : 'clear-input';
    if (inputText.length > 0) {
      if (this.moduleInstance.inputExperience.toLowerCase() === 'stage') {
        this.clearSearchLink.addClass(className);
      } else {
        this.clearSearchLink.show();
      }
    } else {
      if (this.moduleInstance.inputExperience.toLowerCase() === 'stage') {
        this.clearSearchLink.removeClass(className);
      } else {
        this.clearSearchLink.hide();
      }
    }
  }

  /**
     * removes listhistory item from autocomplete.
     * @param {object} event id for element to be removed.
     * @returns {void}
     */
  handleCloseButtonClick(event) {
    this.isLastHistroyItem = $(event.target).parents('li').is(':last-child');
    this.autoCompleteModel.deleteSearchHistory(event.target.getAttribute('id')).then($.proxy(this.getDataSuccessAfterDelete, this), $.proxy(this.getDataFailed, this));
  }

  /**
     * registers events for input box and search button.
     * @returns {void}
     */
  attachEvents() {
    const flyoutLiElm = $(this.container).find('.spa-global-search-suggestions--list li');
    this.searchButton = $(this.container).find(this.searchButtonId);
    this.searchPartialList.on('scroll', $.proxy(this.addShadow, this));
    $(document).on('mouseup', $.proxy(this.handleBodyClick, this));
    $(document).on('keyup', $.proxy(this.handleBodyKeyup, this));
    flyoutLiElm.on('click', $.proxy(this.handleRequestUpdated, this));
    flyoutLiElm.on('keydown', $.proxy(this.handleNavigation, this));
  }

  /**
     * publishes event for search results overlay.
     * @param {event} event to be used to publish the event.
     * @returns {void}
     */
  handleRequestUpdated(event) {
    const li = $(event.target).parents('li');
    if ($(event.target).is('button') || $(li).find('button').is(':focus')) {
      this.handleCloseButtonClick(event);
    } else {
      let inputVal = null;
      if ($(event.target).is('a')) {
        inputVal = $.trim(event.target.getAttribute('searchQuery'));
      } else if ($(event.target.parentNode).is('a')) {
        inputVal = $.trim(event.target.parentNode.getAttribute('searchQuery'));
      }
      $(this.inputTextboxId).val(inputVal);
      window.setTimeout($.proxy(function () {
        $(this.inputTextboxId).focus();
      }, this), 200);
      this.toggleCloseLink(inputVal);
      this.hidePopup();
      this.moduleInstance.Events.pub('global.search.request-updated', {
        query: inputVal,
        target: this.container,
        invoker: $(this.inputTextboxId)
      });
    }
    return false;
  }

  /**
     * Handles body click.
     * @param {event} event param to be used to get target element.
     * @returns {void}
     */
  handleBodyClick(event) {
    event.stopPropagation();
    if (event.target && this.checkIfExternalClick(event.target) && this.flyoutWrapperElem && this.flyoutWrapperElem.classList.contains('show-search')) {
      this.hidePopup();
    }
  }

  /**
     * check for external click outside popup.
     * @param {event} element element to be checked for external click.
     * @returns {void}
     */
  checkIfExternalClick(element) {
    if ($('.spa-global-search-form').length > 0 && element === $('.spa-global-search-form').get(0) || $(this.flyoutWrapperClass).length > 0 && element === $(this.flyoutWrapperClass).get(0)) {
      return false;
    }
    if (element === document.body) {
      return true;
    }
    return element ? this.checkIfExternalClick(element.parentNode) : false;
  }

  /**
     * handles keyup event to capture tab press that will set focus on the 
     * @param {event} event to be used to publish the event.
     * @returns {void}
     */
  handleBodyKeyup(event) {
    if (event.target && event.target.tagName.toLowerCase() !== 'html' && event.target.tagName.toLowerCase() !== 'body' && $(this.flyoutWrapperClass).is(':visible') && this.checkIfExternalToWidget(event.target)) {
      this.hidePopup();
    }
  }

  /**
     * check for external element outside of widget.
     * @param {event} element element to be checked for external click.
     * @returns {void}
     */
  checkIfExternalToWidget(element) {
    if ($(element).parents(this.widgetContainerId).length === 0) {
      return true;
    }
    return false;
  }

  /**
     * Show/hides shadow on scroll.
     * @returns {void}
     */
  addShadow() {
    if (this.searchPartialList.scrollTop > 0) {
      this.searchFlyoutWrapper.addClass('shadow--active');
    } else {
      this.searchFlyoutWrapper.removeClass('shadow--active');
    }
  }

  /**
     * publishes event for search results overlay.
     * @param {event} event to be used to publish the event.
     * @returns {void}
     */
  handleNavigation(event) {
    if (event.keyCode === 27) {
      // esc Key
      this.hidePopup();
      $(this.inputTextboxId).focus();
    }
  }
}

/**
 * A class to get auto complete view
 */
class AutocompleteView {
  /**
    * Creates an instance of AutocompleteView.
    * @param {object} options The options for template details.
    * @memberof GlobalSearchModule
    */
  constructor(options) {
    this.templateId = options.settings.templateId;
    this.moduleInstance = options.moduleInstance;
  }

  /**
    * Called to get applicable view
    * @returns {void}
    */
  getView() {
    return moduleConfig.partials[this.templateId];
  }
}

/**
 * A class that binds data with the view using controller.
 */
class AutoCompleteModel {
  /**
     * Creates an instance of AutoCompleteModel
     * @param {object} options which holds view and model for input box.
     * @memberof GlobalSearchModule
     */
  constructor(options) {
    this.settings = options.settings;
    this.moduleInstance = options.moduleInstance;
    this.isCrossDomain = true;
    this.jcrHelper = this.moduleInstance.jcrHelper;
    this.query = null;
    if (this.moduleInstance.isAuth) {
      this.autoCompleteUrl = this.jcrHelper.getUrl({
        key: 'autoCompleteAuth',
        secureAlways: true
      });
      this.removeSearchHistoryUrl = this.jcrHelper.getUrl({
        key: 'removeSearchHistoryAuth',
        secureAlways: true
      });
    } else {
      this.autoCompleteUrl = this.jcrHelper.getUrl({
        key: 'autoCompleteUnAuth',
        secureAlways: true
      });
      this.removeSearchHistoryUrl = this.jcrHelper.getUrl({
        key: 'removeSearchHistoryUnAuth',
        secureAlways: true
      });
    }
    this.data = null;
    this.items = {
      organic: [],
      history: []
    };
    this.options = {
      itemlimit: this.jcrHelper.getSettings({
        key: 'autocompleteItemLimit'
      }),
      historyItemList: this.jcrHelper.getSettings({
        key: 'authcompleteHistoryItemLimit'
      }),
      suggestedSearchLimit: this.jcrHelper.getSettings({
        key: 'suggestedSearchLimit'
      })
    };
    this.suggestedSearchesText = this.jcrHelper.getLabel({
      key: 'typeAheadSuggested'
    });
    this.searchedHistoryText = this.jcrHelper.getLabel({
      key: 'searchedHistory'
    });
    this.clearSearchHistoryText = this.jcrHelper.getLabel({
      key: 'clearSearchHistory'
    });
    this.removeSearchHistoryText = this.jcrHelper.getLabel({
      key: 'removeSearchHistory'
    });
    this.viewport = 'large';
    const mediaQueryData = this.moduleInstance.Store.getData('currentMQ');
    //set viewport for responsive page | for non-responsive keep large
    if (mediaQueryData && document.getElementsByTagName('body')[0]?.dataset?.spartaVersion) {
      this.viewport = mediaQueryData.viewport;
    }
  }

  /**
     * Gets data from service .
     * Event subscriber must remove any forbidden characters present and
     * create complete request param using query.
     * @param {options} options holds updated query .
     * @param {element} flyoutWrapper flyoutwrapper element.
     * @returns {Promise} returns promise
     */
  getData(options = {}) {
    this.ps = $.Deferred();
    let isPopupVisible = false;
    this.flyoutWrapper = document.querySelector('.spa-global-search-flyout--wrapper');
    if (this.flyoutWrapper) {
      if (this.flyoutWrapper.classList.contains('show-search')) {
        isPopupVisible = true;
      }
    }
    if (this.query !== options.query || !isPopupVisible) {
      this.query = options.query;
      const transportObj = {
        cache: false,
        method: "POST",
        data: JSON.stringify(this.getRequest(options.query)),
        dataType: "json",
        contentType: "application/json",
        url: this.autoCompleteUrl,
        xhrFields: {
          withCredentials: true
        },
        success: $.proxy(this.successCallback, this),
        error: $.proxy(this.failureCallback, this)
      };
      let arrSearchContext = window.location.pathname && window.location.pathname.length > 1 ? window.location.pathname.split('/') : null;
      let searchContext = arrSearchContext && arrSearchContext.length > 1 ? arrSearchContext[1] : null;
      if (searchContext) {
        transportObj.headers = {
          "search-context": searchContext
        };
      }
      spartaTransportUtility.subscribe(transportObj);
    }
    return this.ps;
  }

  /**
     * Displays the data in the UI.
     * @returns {object} labels & autocompleteCardsSettings
     */
  getUIData() {
    let cardsSettings = this.jcrHelper.getSearchData().autocompleteCardsSettings;
    if (this.viewport.indexOf('large') === -1) {
      cardsSettings.layerStartADA = '';
      cardsSettings.layerEndADA = '';
    }
    return {
      labels: this.jcrHelper.getAllLabels(),
      autocompleteCardsSettings: cardsSettings
    };
  }

  /**
     * Displays the data in the UI.
     * @param {options} query holds updated query.
     * @returns {request} request
     */
  getRequest(query = {}) {
    if (query === '') {
      this.options.itemlimit = this.jcrHelper.getSettings({
        key: 'suggestedSearchLimit'
      });
    } else {
      this.options.itemlimit = this.jcrHelper.getSettings({
        key: 'autocompleteItemLimit'
      });
    }
    return {
      term: GlobalSearchCommonUtility.string.insecure(query),
      lang: this.moduleInstance.lang
    };
  }

  /**
     * Called when this getdata method returns data.
     * @param {object} data the options this module was initialized with.
     * @returns {void}
     */
  successCallback(data) {
    if (data && data.length > 0) {
      this.data = this.processData(data);
      this.data = $.extend(this.data, this.getUIData());
    } else {
      this.data = data;
    }
    this.ps.resolve(this.data);
  }

  /**
     * Called when this servie failed failure  .
     * @param {object} data The options this module was initialized with.
     * @returns {void}
     */
  failureCallback(data) {
    this.ps.reject({
      ErrorMsg: 'Failed to get data',
      data
    });
  }

  /**
     * Called when this getdata method returns data.
     * @param {object} responses The options this module was initialized with.
     * @returns {void}
     */
  processData(responses) {
    let org = [];
    let his = [];
    let i;
    let orgIndex = 0;
    let hisIndex = 0;
    let temp;
    for (i = 0; i < responses.length; i++) {
      try {
        temp = $.trim(responses[i].q).replace(/[ \n\t]+/g, ' ');
        responses[i].fr = temp.replace(/ /g, '-');
        if (this.query) {
          responses[i].fq = GlobalSearchCommonUtility.string.replaceAll(temp, this.query, '<span class="light-text">' + this.query + '</span>').toLocaleLowerCase();
        } else {
          responses[i].fq = GlobalSearchCommonUtility.string.replaceAll(temp, temp, '<span class="light-text">' + temp + '</span>').toLocaleLowerCase();
        }

        //Organic search
        if (orgIndex < this.options.itemlimit) {
          if (!responses[i].history || responses[i].history && responses[i].history === false) {
            org.push(responses[i]);
            orgIndex++;
          }
        }

        //History items
        if (hisIndex < this.options.historyItemList) {
          if (responses[i].history && responses[i].history === true) {
            his.push(responses[i]);
            hisIndex++;
          }
        }
      } catch (error) {
        console.log(error);
        continue;
      }
    }

    // data processing as per cardHelper
    let processedData = {};
    processedData = this.jcrHelper.getSearchData();
    processedData.cardDetails = {
      autocompleteSuggestion: true,
      autoComplete: org,
      autoCompleteHistory: his,
      searchTip: false,
      suggestedSearchesText: this.suggestedSearchesText,
      searchedHistoryText: this.searchedHistoryText,
      clearSearchHistoryText: this.clearSearchHistoryText,
      removeSearchHistoryText: this.removeSearchHistoryText
    };
    return processedData;
  }

  /**
     * Called on click of delete history.
     * @param {object} id unique identifier for list item.
     * @param {object} options the options this module was initialized with.
     * @returns {Promise} delete hisotry promise
     */
  deleteSearchHistory(id, options = {}) {
    this.psDeleteHistory = $.Deferred();
    this.successDeleteHistory(id);
    let request = {
      id: id
    };
    const transportObj = {
      cache: false,
      method: "POST",
      data: JSON.stringify(request),
      dataType: "json",
      contentType: "application/json",
      url: this.removeSearchHistoryUrl,
      xhrFields: {
        withCredentials: true
      },
      success: $.proxy(this.successDeleteHistoryCallback, this),
      error: $.proxy(this.deleteHistoryFailureCallback, this)
    };
    spartaTransportUtility.subscribe(transportObj);
    return this.psDeleteHistory;
  }

  /**
     * Gets data from service .
     * Event subscriber must remove any forbidden characters present and
     * create complete request param using query.
     * @param {id} id holds updated query.
     * @param {object} data service response data.
     * @returns {void}
     */
  successDeleteHistory(id) {
    this.data = this.removeFromLocalHistory(id, this.data);
    this.data = $.extend(this.data, this.getUIData());
    this.psDeleteHistory.resolve(this.data);
  }

  /**
     * Gets data from service .
     * Event subscriber must remove any forbidden characters present and
     * create complete request param using query.
     * @param {id} id holds id .
     * @param {data} data holds data .
     * @returns {object} organic & history data
     */
  removeFromLocalHistory(id, data) {
    let i;
    const l = data.cardDetails.autoCompleteHistory.length;
    const history = [];
    for (i = 0; i < l; i++) {
      if (data.cardDetails.autoCompleteHistory[i].id !== id) {
        history.push(data.cardDetails.autoCompleteHistory[i]);
      }
    }
    let processedData = {};
    processedData = this.jcrHelper.getSearchData();
    processedData.cardDetails = {
      autocompleteSuggestion: true,
      autoComplete: data.cardDetails.autoComplete,
      autoCompleteHistory: history,
      searchTip: false,
      suggetions: this.suggestionsText,
      suggestedSearchesText: this.suggestedSearchesText,
      searchedHistoryText: this.searchedHistoryText,
      clearSearchHistoryText: this.clearSearchHistoryText,
      removeSearchHistoryText: this.removeSearchHistoryText
    };
    return processedData;
  }

  /**
     * Gets data from service .
     * Event subscriber must remove any forbidden characters present and
     * create complete request param using query.
     * @param {object} data service response data.
     * @returns {void}
     */
  successDeleteHistoryCallback(data) {
    //console.log('Successfully deleted the history element');
  }

  /**
     * Gets data from service .
     * Event subscriber must remove any forbidden characters present and
     * create complete request param using query.
     * @param {data} data holds data.
     * @returns {void}
     */
  deleteHistoryFailureCallback(data) {
    this.psDeleteHistory.reject({
      ErrorMsg: 'Failed to delete history data',
      data
    });
  }
}

const Template$4 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate$4 = function (data, options) {
  return Template$4(data, options);
};

const Template$3 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "    <div class=\"spa-global-search-suggestions spa-global-search--partial\">\r\n    </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "    <div class=\"spa-global-search-tips spa-global-search--partial\">\r\n    </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spa-global-search--flyout\">\r\n  <div id=\"global-search-input-container-md\"></div>\r\n  <div class=\"spa-global-search--partial-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"cardDetails") : stack1)) != null ? lookupProperty(stack1,"autocompleteSuggestion") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"cardDetails") : stack1)) != null ? lookupProperty(stack1,"searchTip") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>";
},"useData":true});
const renderTemplate$3 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$3(data, options);
};

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"searchTipTitle") : depth0), depth0))
    + "\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"searchTipTitle1") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":9,"column":4}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"searchTipTitle1") : depth0), depth0))
    + "\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"serviceUnavailable") : depth0), depth0))
    + "\r\n    ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <ul class=\"spa-global-search-tips--list\" role=\"list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"searchTipResult") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":24,"column":13}}})) != null ? stack1 : "")
    + "  </ul>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li role=\"listitem\" id=\"spa-global-search-tip-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":15,"column":50},"end":{"line":15,"column":60}}}) : helper)))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"URL") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":16,"column":6},"end":{"line":22,"column":13}}})) != null ? stack1 : "")
    + "    </li>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <a href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"URL") : depth0), depth0))
    + "\">\r\n        "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"suggestionName") || (depth0 != null ? lookupProperty(depth0,"suggestionName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"suggestionName","hash":{},"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":18,"column":26}}}) : helper)))
    + "\r\n      </a>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"suggestionName") || (depth0 != null ? lookupProperty(depth0,"suggestionName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"suggestionName","hash":{},"data":data,"loc":{"start":{"line":21,"column":6},"end":{"line":21,"column":24}}}) : helper)))
    + "\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"searchServiceUnavailable") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":2},"end":{"line":34,"column":2}}})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <ul class=\"spa-global-search-tips--unavailable\" role=\"list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"searchServiceUnavailable") : depth0),{"name":"each","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":4},"end":{"line":32,"column":13}}})) != null ? stack1 : "")
    + "  </ul>\r\n  ";
},"16":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <li role=\"listitem\" id=\"spa-global-search-tip-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":29,"column":50},"end":{"line":29,"column":60}}}) : helper)))
    + "\">\r\n      "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"serviceError") || (depth0 != null ? lookupProperty(depth0,"serviceError") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"serviceError","hash":{},"data":data,"loc":{"start":{"line":30,"column":6},"end":{"line":30,"column":22}}}) : helper)))
    + "\r\n    </li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spa-global-search-tips--container\">\r\n  <div class=\"spa-global-search-tips--label\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"searchTipTitle") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":9,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  <h3 class=\"spa-global-search-tips--title\">Search tips:</h3>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"searchTipResult") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":12,"column":2},"end":{"line":34,"column":9}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate$2 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <li role=\"listitem\" id=\"spa-global-search-suggestion-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":4,"column":55},"end":{"line":4,"column":65}}}) : helper)))
    + "\">\r\n    <div class=\"spa-global-search-suggestions--list-clickable\">\r\n      <a href=\"javascript:void(0);\" searchQuery=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"q") || (depth0 != null ? lookupProperty(depth0,"q") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"q","hash":{},"data":data,"loc":{"start":{"line":6,"column":49},"end":{"line":6,"column":54}}}) : helper)))
    + "\" data-bactmln=\"search-module-suggestion-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fr") || (depth0 != null ? lookupProperty(depth0,"fr") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fr","hash":{},"data":data,"loc":{"start":{"line":6,"column":95},"end":{"line":6,"column":101}}}) : helper)))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":8},"end":{"line":9,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"fq") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":8},"end":{"line":13,"column":15}}})) != null ? stack1 : "")
    + "      </a>\r\n    </div>\r\n  </li>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <span class=\"spa-icon icon-"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "\"></span>\r\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"fq") || (depth0 != null ? lookupProperty(depth0,"fq") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fq","hash":{},"data":data,"loc":{"start":{"line":11,"column":8},"end":{"line":11,"column":16}}}) : helper))) != null ? stack1 : "")
    + "\r\n        <span class=\"ada-hidden\"> "
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"suggestedSearchesText") : stack1), depth0))
    + " </span>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <li role=\"listitem\" id=\"spa-global-search-suggestion-history-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":19,"column":63},"end":{"line":19,"column":73}}}) : helper)))
    + "\">\r\n    <div class=\"spa-global-search-suggestions--list-clickable\">\r\n      <span class=\"spa-icon icon-history\"></span>\r\n      <a href=\"javascript:void(0);\" searchQuery=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"q") || (depth0 != null ? lookupProperty(depth0,"q") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"q","hash":{},"data":data,"loc":{"start":{"line":22,"column":49},"end":{"line":22,"column":54}}}) : helper)))
    + "\" class=\"history-item\"\r\n        data-bactmln=\"search-module-history-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fr") || (depth0 != null ? lookupProperty(depth0,"fr") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fr","hash":{},"data":data,"loc":{"start":{"line":23,"column":44},"end":{"line":23,"column":50}}}) : helper)))
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"fq") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":27,"column":15}}})) != null ? stack1 : "")
    + "      </a>\r\n    </div>\r\n    <button type=\"button\" class=\"spa-global-search-suggestions--remove clear-autocomplete-history\" id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\"\r\n      data-bactmln=\"search-module-history-remove-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"fr") || (depth0 != null ? lookupProperty(depth0,"fr") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fr","hash":{},"data":data,"loc":{"start":{"line":31,"column":49},"end":{"line":31,"column":55}}}) : helper)))
    + "\">\r\n      "
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"removeSearchHistoryText") : stack1), depth0))
    + "\r\n      <span class=\"ada-hidden\"> "
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"clearSearchHistoryText") : stack1), depth0))
    + " "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"q") || (depth0 != null ? lookupProperty(depth0,"q") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"q","hash":{},"data":data,"loc":{"start":{"line":33,"column":67},"end":{"line":33,"column":72}}}) : helper)))
    + " </span>\r\n    </button>\r\n  </li>\r\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"fq") || (depth0 != null ? lookupProperty(depth0,"fq") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fq","hash":{},"data":data,"loc":{"start":{"line":25,"column":8},"end":{"line":25,"column":16}}}) : helper))) != null ? stack1 : "")
    + "\r\n        <span class=\"ada-hidden\"> "
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"searchedHistoryText") : stack1), depth0))
    + " </span>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<h3 class=\"spa-global-search-suggestions--title\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"suggestedSearchesText") : stack1), depth0))
    + "</h3>\r\n<ul class=\"spa-global-search-suggestions--list\" role=\"list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"autoComplete") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":17,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"autoCompleteHistory") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":2},"end":{"line":36,"column":11}}})) != null ? stack1 : "")
    + "</ul>";
},"useData":true,"useDepths":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"cardHelper")||(depth0 && lookupProperty(depth0,"cardHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"autocompleteCardsSettings") : stack1),{"name":"cardHelper","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":54}}}));
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global-gt.modules/global-search-autocomplete-module",
  "version": "1.0.8",
  "id": "globalSearchAutocompleteModule",
  "containerID": "globalGtGlobalSearchAutocompleteModule",
  "moduleName": "global-gt-global-search-autocomplete-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "global-search-autocomplete-module",
  "data": {
    "init": "GlobalSearchAutocompleteModule",
    "options": {
      "globalSearchJcr": "{{json globalSearchJcr}}"
    }
  },
  "moduleParams": [{
    "name": "isAuth",
    "type": "boolean",
    "description": "This parameter controls the rendering of module in authenticated vs unauthenticated mode. The default is false.",
    "default": false,
    "values": [true, false]
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$4(context, {
      "helpers": {
        cardHelper
      },
      "partials": {
        "flyout": renderTemplate$3,
        "search-suggestions-tips": renderTemplate$2,
        "search-suggestions": renderTemplate$1,
        "search-ui-suggestions": renderTemplate
      }
    });
  },
  "template": renderTemplate$4,
  "partials": {
    "flyout": renderTemplate$3,
    "search-suggestions-tips": renderTemplate$2,
    "search-suggestions": renderTemplate$1,
    "search-ui-suggestions": renderTemplate
  },
  "helpers": {
    cardHelper
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-transport-utility": "^1.0.0",
    "@sparta.global-gt.utilities/global-search-common-utility": "^1.0.0",
    "@sparta.global-gt.utilities/global-search-jcr-utility": "^1.0.0",
    "@sparta.global.helpers/card-helper": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.7.1"
  },
  "stores": []
};

/**
 * Implementation of the global-search-autocomplete-module module.
 * @copyright 2021-7-26
 * @since 7/26/2021, 6:16:47 AM
 * @author Thoutireddy, Ramakanth
 * @file
 */

/* global Module */

/**
 * The GlobalSearchAutocompleteModule Module.
 * This module is responsible for providing autocomplete behaviour and UI.
 * @export
 * @class
 */
class GlobalSearchAutocompleteModule extends Module {
  /**
   * Creates an instance of GlobalSearchAutocompleteModule.
   * @param {object} options Used for Initialization of modules.
   * @memberof GlobalSearchAutocompleteModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.site = 'OLB';
    this.lang = 'en';
    this.inputExperience = 'header';
    this.resultsExperience = 'flyout';
    this.resultsContainerId = '';
    this.imports = {
      AutocompleteController: AutoCompleteController,
      AutocompleteModel: AutoCompleteModel,
      AutocompleteView
    };
    this.isAuth = false;
    this.jcrHelper = null;
    this.Widget = window.spaWidgetParams[this.applicationContext.name][this.applicationContext.version][this.applicationContext.id];
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    this.site = GlobalSearchCommonUtility.site.getCurrentSite();
    this.lang = GlobalSearchCommonUtility.lang.getPageLanguage();
    this.isAuth = this.params && this.params.isAuth;
    const widgetOptionsStr = JSON.parse(this.applicationContainer.getAttribute('data-sparta-options'));
    if (widgetOptionsStr.inputExperience) {
      this.inputExperience = widgetOptionsStr.inputExperience;
    }
    if (widgetOptionsStr.resultsExperience) {
      this.resultsExperience = widgetOptionsStr.resultsExperience;
    }
    this.jcrHelper = new GlobalSearchJcrUtility({
      site: this.site,
      searchJcrData: this.settings.globalSearchJcr,
      moduleInstance: this
    });
    const componentsSetting = this.jcrHelper.getComponentsSetting({
      inputExperience: this.inputExperience,
      resultsExperience: this.resultsExperience,
      componentName: 'autocomplete'
    });
    const viewType = componentsSetting.view.type;
    const view = new this.imports[viewType]({
      settings: componentsSetting.view.attributes,
      moduleInstance: this
    });
    const modelType = componentsSetting.model.type;
    const model = new this.imports[modelType]({
      settings: componentsSetting.model.dataServices,
      moduleInstance: this
    });
    const controllerType = componentsSetting.controller.type;
    const controller = new this.imports[controllerType]({
      view,
      model,
      container: this.settings.$target,
      moduleInstance: this
    });
    controller.init();
  }
}
registerModuleClass({
  moduleClass: GlobalSearchAutocompleteModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GlobalSearchAutocompleteModule as default, moduleConfig };
